angular.module('impactx.greetingcard').controller('BasketItemVerificationTraceCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    '$config',
    'ToastService',
    'bkiId',
    BasketItemVerificationTraceCtrl
]);

function BasketItemVerificationTraceCtrl($scope, dataGen, $mdDialog, TranslationService, $config, ToastService, bkiId) {
    var self = this;
    $scope.isNew = true;
    var firstTemplateCall = true;
    dataGen.getData({}, {bkiId: bkiId}, "/basket/verificationtrace/item/view").then(function (data) {
        $scope.data = data.data.gct;
        $scope.trns = data.trns;
        $scope.isNew = data.data.isNew;
        $scope.trns.save = TranslationService.get("save");
        $scope.trns.delete = TranslationService.get("delete");
        $scope.trns.abort = TranslationService.get("abort");
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
    });

    this.saveVerificationTrace = function () {
        dataGen.postAsForm($scope, {bkiId: bkiId, gct: $scope.data}, "/basket/verificationtrace/item/save").then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    this.deleteVerificationTrace = function () {
        dataGen.postAsForm($scope, {bkiId: bkiId}, "/basket/verificationtrace/item/delete").then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
        });
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };
    
    this.updateGCTData = function (selected) {
        var tempScope = {};
        if (!$scope.data.gctId || !firstTemplateCall) {
            if (selected) {
                dataGen.getData(tempScope, {gctId: selected.id}, "/basket/greetingcard/template/data").then(function () {
                   $scope.data.gctId = tempScope.data.gctId;
                   $scope.data.isPersonal = tempScope.data.isPersonal;
                });
            }
            else {
                $scope.data.gctId = 0;
                if($scope.data.isPersonal)
                {
                    $scope.data.isPersonal.readOnly = false;
                }
            }
        }
        firstTemplateCall = false;
    };
}
